import {useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {ToastService} from '../../../AppToast';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {RegisterInvoiceService as Service} from '../../../service/invoice/RegisterInvoiceService';
export const useDialogRegisterInvoice = (props) => {
  const [requiredParams, setRequiredParams] = useState(null);
  const {registerInvoices, registerInvoice, selectionMode} = props;
  const [registerInvoiceOptions, setRegisterInvoiceOptions] = useState([]);
  const [display, setDisplay] = useState(false);
  const [invoiceSerials, setInvoiceSerials] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [perPageOptions, setPerPageOptions ]= useState([50, 100, 200,300]);
  const showRegisterInvoiceDialog = () => {
    const _invoiceSerials = [];
    registerInvoices.forEach(item => {
      _invoiceSerials.push({value: item.symbolCode, label: item.label});
    });
    setInvoiceSerials(_invoiceSerials);
    setDisplay(true);
  }

  useEffect(() => {
    setRequiredParams({});
  },[registerInvoices])
   
  const handleSubmit = () => {
    let InvoiceIdArray;
    if (Array.isArray(selectedItems) && selectedItems.length) {
      InvoiceIdArray = selectedItems.map(({id}) => id);
      copyRegisterInvoice(InvoiceIdArray);
    }  
  }

  const copyRegisterInvoice = (data) => {
    Service.copyRegisterInvoice(data).then(res => {
      setDisplay(false);
      refreshLazyData();
    })
  }

  const {render: renderDataTable, refreshLazyData, selectedItems, clearItems} = useDataTable({
    header: '',
    dataKey: 'id',
    columns: [
      {field: 'invoiceTypeName', header: 'Loại hóa đơn', width: 430, matchMode: 'contains'},
      {field: 'symbolCode', header: 'Ký hiệu', width: 200, matchMode: 'contains'},
    ],
    heightCalc: 350,
    requiredParams,
    getList: (params) => {
      return Service.getUsingOfYearList(params);
    },
    selectionMode,
    perPageOptions
  });

  const renderRegisterInvoice = () => {
    return (
      <Dialog header="TẠO MẪU HÓA ĐƠN THEO NĂM TÀI CHÍNH" visible={display} style={{width: '60rem'}} position="top" onHide={() => setDisplay(false)}>
        <div className="grid">
          <div className="col-12">
            <div>
            Theo nghị định <b>123/2020/NĐ-CP </b>và Thông tư <b>78/2021/TT-BTC</b>, Ký hiệu hóa đơn được đánh theo năm và số hóa đơn bắt đầu lại số 1 từ 01/01 hoặc ngày bắt đầu sử dụng hóa đơn điện tử.
            <br/>
Quý khách vui lòng tích chọn các ký hiệu cần sử dụng và ấn <b>Copy mẫu hóa đơn</b> để chuyển sang năm sau
            </div>
            {renderDataTable()}
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label="Copy mẫu hóa đơn" icon="pi pi-upload" onClick={handleSubmit} loading={submitting} className="p-button-sm mr-2"/>
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    );
  }

  return {renderRegisterInvoice, showRegisterInvoiceDialog};

}